import React, { useEffect } from "react";
import "./services.css";
import { useNavigate } from "react-router-dom";
import { logEvent } from "../../../../utils/analytics";
import { useServices } from "../../customHooks";
import { Button, Container, Grid } from "@mui/material";

function Services(props) {
  const { services, fetchServices } = useServices();
  const navigate = useNavigate();

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <>
      <Container maxWidth={'xl'} className="py-4 home-ser">
        <Grid className="container pt-3">
          <Grid className="text-center">
            <h6 className="section-title text-center text-primary text-uppercase title-tl">
              Temple
            </h6>
            <h1 className="mb-1">
              <span className="text-secundary">Services</span>
            </h1>
          </Grid>
          <Grid className="container py-3">
            <Grid className="row g-3">
              {services?.map((item) => (
                <Grid
                  key={item._id}
                  className="col-lg-2 col-md-6 list-grid grid-item"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate(item.slug === "donation"
                        ? "/donation"
                        : `/services/${item.slug}`);
                      logEvent(
                        "Home Page Services Interaction",
                        "Service Clicked",
                        item.title
                      );
                    }}
                  >
                    <img
                      className="img-fluid rounded mb-2"
                      src={item.image}
                      alt=""
                    />
                    <h4 className="mb-0 service-item2">{item.title}</h4>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Services;
